module.exports = __webpack_public_path__ + "img/depositphotos_47009329-stock-photo-glazed-and-unglazed-ceramic-flower.png";